import type { VisualizationProps } from './types';

/**
 * HallwaySVG — прихожая: шкаф с дверцей + крючки на боковой стене.
 * Зоны: facade, corpus, handles, hooks. Без countertop. Конвенции — `./types.ts`.
 */
export function HallwaySVG({
  facadeColor,
  corpusColor,
  handlesColor,
  // Defensive fallback (direct SVG usage без wrapper'а — тесты, Storybook).
  hooksColor = '#999999',
}: VisualizationProps) {
  return (
    <svg
      viewBox="0 0 320 200"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0" y="0" width="320" height="200" fill="#f9f6f2" />
      <rect x="0" y="185" width="320" height="15" fill="#d8cfc4" />
      <rect
        data-testid="zone-corpus"
        x="80"
        y="20"
        width="160"
        height="165"
        fill={corpusColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-facade"
        x="88"
        y="28"
        width="144"
        height="149"
        fill={facadeColor}
        stroke="#000000"
        strokeWidth="1"
        rx="2"
      />
      <rect
        data-testid="zone-handles"
        x="220"
        y="98"
        width="2"
        height="12"
        fill={handlesColor}
        rx="1"
      />
      <rect
        data-testid="zone-hooks"
        x="270"
        y="60"
        width="3"
        height="10"
        fill={hooksColor}
        rx="1"
      />
      <rect x="270" y="100" width="3" height="10" fill={hooksColor} rx="1" />
      <text
        x="160"
        y="105"
        textAnchor="middle"
        fontSize="10"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        1
      </text>
      <text
        x="60"
        y="105"
        textAnchor="middle"
        fontSize="10"
        fill="#000000"
        fontWeight="600"
        fontFamily='"Manrope Variable", sans-serif'
      >
        2
      </text>
    </svg>
  );
}
